import { PageHeader, CardComponent } from '@/components/molecules'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { ActivitiesList } from '@/containers'
import { HeaderTitle } from '@/components/atoms'
import { Header } from '@/utils/constants/header'
import { useActivites } from '@/hooks/useActivites'

import { useDispatch } from 'react-redux'
import { resetActivityData } from '@/store/slices/activitySlice'

export const PgcsHome = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { activityListData } = useActivites()

  const handleNavigateToSalesTargetAdd = () => {
    navigate(ROUTES.SALES_TARGET_ADD)
  }
  const handleNavigateToActivityAdd = () => {
    dispatch(resetActivityData({}))
    navigate(ROUTES.ACTIVITY_ADD)
  }
  const cardList = [
      {
        centralIcon: 'local_police',
        ctaPrimary: {
          text: 'Add Activity',
          onClick: () => handleNavigateToActivityAdd(),
        },
        title: `${activityListData?.activeCount ?? ''} Activities are active`,
      },
      {
        centralIcon: 'location_searching',
        ctaPrimary: { text: 'Add Sales Target', onClick: () =>
          handleNavigateToSalesTargetAdd()
        },
        title: `XX Sales Targets are active`,
      },
    ];

  return (
    <div className="pgcsHomeContainer flex flex-col">
      <PageHeader title="PGCS" />
      <div className="targetCardComponent mb-5">
        <CardComponent cardList={cardList} />
      </div>
      <div style={{ backgroundColor: '#1D1D1D', paddingLeft: '16px' }} className="pgcsHomeTitleSection relative">
        <HeaderTitle headingLevel={Header.SectionTitle} title={"Activities"} className="pgcsHomeDataTableHeading" />
      </div>
      <div
        style={{ backgroundColor: '#1D1D1D', paddingLeft: '16px' }}>
        <ActivitiesList />
      </div>
    </div>
  )
}
